export const MenuItems = [
  {
    id: "1",
    name: "Home",
    href: "/",
  },
  {
    id: "2",
    name: "About Us",
    href: "/about-us",

    submenu: [
      { id: "2-1", name: "Infrastructure", href: "/infrastructure" }, 

      // { id: "2-3", name: "CSR", href: "/coming-soon" },
      {
        id: "2-4",
        name: "Board Report MGT7 22-2023",

        href: "https://www.emergeglass.in/boardreportmgt17.pdf",
      },
      {
        id: "2-5",
        name: "Board Report MGT7 23-2024",

        href: "https://www.emergeglass.in/boardreportmgt2024.pdf",
      },
    ],
  },
  {
    id: "3",
    name: "Products",
    href: "/products",

    submenu: [
      { id: "2-1", name: "Beer Bottle", href: "/beer-bottle" },
      { id: "2-2", name: "Food Jar", href: "/food-jar" },
      { id: "2-3", name: "Liquor Bottles", href: "/liquor-bottle" },
      {
        id: "2-4",
        name: "Pharma Products",

        href: "/pharma-bottle",
      },
      { id: "2-5", name: "Sheet Glass", href: "/sheet-glass" },
    ],
  },

  {
    id: "4",
    name: "What We Do",
    href: "/emerge-renewables",

    submenu: [
      { id: "4-1", name: "Emerge Renewables", href: "/emerge-renewables" }, 
      
   
    ],
  },

];

export const MenuItems2 = [
  // {
  //   id: "4",
  //   name: "Clients",
  //   href: "/clients",

  //   submenu: [{ id: "4-1", name: "Certificates", href: "/certificate" }],
  // },

  {
    id: "4",
    name: "Clients",
    href: "/clients",
  },
  {
    id: "5",
    name: "Certificates",
    href: "/certificate",
  },
  // {
  //   id: "5",
  //   name: "Media & PR",
  //   href: "https://www.emergeglass.in/media-pr.pdf",

  //   submenu: [
  //     { id: "5-1", name: "Events", href: "/coming-soon" },
  //     { id: "5-2", name: "Gallery", href: "/coming-soon" },
  //   ],
  // },
  {
    id: "6",
    name: "Contact Us",
    href: "/contact-us",

    submenu: [{ id: "6-1", name: "Career", href: "/career", target: "" }],
  },
];
